var _style, _g, _polygon, _path, _path2, _path3, _rect, _path4, _path5, _polygon2, _polygon3, _path6, _circle, _circle2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    viewBox: "60 128.4 380 243.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#F48120;}\n\t.st2{fill:#231F20;}\n\t.st3{fill:url(#XMLID_3_);}\n\t.st4{opacity:0.65;fill:url(#XMLID_4_);enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_432_"
  })), /*#__PURE__*/React.createElement("g", null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_428_",
    className: "st0",
    points: "61.3,129.9 438.6,129.9 438.6,370.1 61.4,370.1  "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_427_",
    className: "st1",
    d: "M437.3,263.5c0,0-103.1,72.7-291.9,105.3h291.9V263.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st2",
    d: "M438.6,128.5H60v243h380V128.4h-1.4V128.5z M437.3,131.2c0,2.7,0,234.8,0,237.5   c-2.7,0-371.8,0-374.5,0c0-2.7,0-234.8,0-237.5C65.5,131.2,434.5,131.2,437.3,131.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M93.2,202.8H77.5v55h15.7c8.3,0,14.3-2,19.6-6.3c6.3-5.2,10-13,10-21.1C122.7,214.1,110.6,202.8,93.2,202.8z    M105.8,244.2c-3.4,3-7.7,4.4-14.7,4.4h-2.9v-36.4h2.9c6.9,0,11.1,1.2,14.7,4.4c3.7,3.3,5.9,8.4,5.9,13.7   C111.7,235.6,109.5,240.9,105.8,244.2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_422_",
    x: 127.7,
    y: 202.8,
    className: "st2",
    width: 10.7,
    height: 55
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_421_",
    className: "st2",
    d: "M164.6,223.9c-6.4-2.4-8.3-4-8.3-6.9c0-3.5,3.4-6.1,8-6.1c3.2,0,5.9,1.3,8.6,4.5l5.6-7.3   c-4.6-4-10.1-6.1-16.2-6.1c-9.7,0-17.2,6.8-17.2,15.8c0,7.6,3.5,11.5,13.5,15.1c4.2,1.5,6.3,2.5,7.4,3.1c2.1,1.4,3.2,3.4,3.2,5.7   c0,4.5-3.5,7.8-8.3,7.8c-5.1,0-9.2-2.6-11.7-7.3l-6.9,6.7c4.9,7.3,10.9,10.5,19,10.5c11.1,0,19-7.4,19-18.1   C180.5,232.4,176.8,228.4,164.6,223.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_420_",
    className: "st2",
    d: "M183.8,230.4c0,16.2,12.7,28.7,29,28.7c4.6,0,8.6-0.9,13.4-3.2v-12.6c-4.3,4.3-8.1,6-12.9,6   c-10.8,0-18.5-7.8-18.5-19c0-10.6,7.9-18.9,18-18.9c5.1,0,9,1.8,13.4,6.2V205c-4.7-2.4-8.6-3.4-13.2-3.4   C196.9,201.6,183.8,214.4,183.8,230.4z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_419_",
    className: "st2",
    points: "311.4,239.8 296.7,202.8 285,202.8 308.3,259.2 314.1,259.2 337.8,202.8 326.2,202.8     "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_418_",
    className: "st2",
    points: "342.7,257.8 373.1,257.8 373.1,248.5 353.4,248.5 353.4,233.7 372.4,233.7    372.4,224.4 353.4,224.4 353.4,212.2 373.1,212.2 373.1,202.8 342.7,202.8  "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M415.6,219.1c0-10.3-7.1-16.2-19.5-16.2h-15.9v55h10.7v-22.1h1.4l14.8,22.1h13.2L403,234.7   C411.1,233,415.6,227.5,415.6,219.1z M394,228.2h-3.1v-16.7h3.3c6.7,0,10.3,2.8,10.3,8.2C404.5,225.2,400.9,228.2,394,228.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 274.0753,
    y1: 246.053,
    x2: 253.8214,
    y2: 277.7647,
    gradientTransform: "matrix(1 0 0 -1 0 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F89F20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2502,
    style: {
      stopColor: "#F79A20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5331,
    style: {
      stopColor: "#F68D20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6196,
    style: {
      stopColor: "#F58720"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7232,
    style: {
      stopColor: "#F48120"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F37521"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_415_",
    className: "st3",
    cx: 259.1,
    cy: 230.5,
    r: 29.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 270.8777,
    y1: 246.4798,
    x2: 241.276,
    y2: 304.338,
    gradientTransform: "matrix(1 0 0 -1 0 500)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F58720"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3587,
    style: {
      stopColor: "#E16F27"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    style: {
      stopColor: "#D4602C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    style: {
      stopColor: "#D05B2E"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_414_",
    className: "st4",
    cx: 259.1,
    cy: 230.5,
    r: 29.3
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_436_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M422.4,204.9c0-1-0.7-1.5-1.8-1.5H419v4.8h1.2v-1.9l1.4,1.9h1.4l-1.6-2C422,206.1,422.4,205.6,422.4,204.9z     M420.4,205.6h-0.2v-1.3h0.2c0.6,0,0.9,0.2,0.9,0.6C421.3,205.4,421,205.6,420.4,205.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M420.8,201.6c-2.3,0-4.2,1.9-4.2,4.2s1.9,4.2,4.2,4.2c2.3,0,4.2-1.9,4.2-4.2S423.1,201.6,420.8,201.6z     M420.8,209.3c-1.8,0-3.4-1.5-3.4-3.5c0-1.9,1.5-3.5,3.4-3.5c1.8,0,3.3,1.6,3.3,3.5C424.1,207.7,422.6,209.3,420.8,209.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.401e18378c025733c3c937f84286c99e.svg";
export { ForwardRef as ReactComponent };